import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "src/components/Link";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { Show } from "src/components/PrivateRoute/Show";
import { ONLY_FOR } from "src/components/PrivateRoute/types";
import { PATHNAMES } from "src/constants/routes";
import { promoBannerTrns } from "./trns";

export const PromoBanner: FC = () => {
  const { t } = useTranslation();

  return (
    <section className="container">
      <div className="flex flex-col lg:flex-row gap-y-8 bg-about-us-promo-banner p-10 rounded-20">
        <div className="flex-1">
          <h4 className="text-white-base text-xl font-bold">
            {t(promoBannerTrns.title)}
          </h4>

          <p className="text-purple-lighter mt-5">
            {t(promoBannerTrns.subtitle)}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row flex-1 self-start gap-5 w-full">
          <Link className="flex-1" href={PATHNAMES.OPPORTUNITIES}>
            <Button className="w-full" variant={ButtonVariants.SHADOW_PRIMARY}>
              {t(promoBannerTrns.learnMoreButton)}
            </Button>
          </Link>

          <Show onlyFor={ONLY_FOR.UNAUTHORIZED}>
            <Link className="flex-1" href={PATHNAMES.REGISTRATION}>
              <Button
                className="w-full"
                variant={ButtonVariants.SHADOW_SECONDARY}
              >
                {t(promoBannerTrns.signUpNowButton)}
              </Button>
            </Link>
          </Show>
        </div>
      </div>
    </section>
  );
};
